import { sendGet } from '@/Utils/api';

export type ServiceFeeResponse = {
  gourmet: number;
  gourmetConfig: {
    tier: string;
    unit: string;
    chargePerUnit: {
      amount: number;
      currency: string;
    };
    chargePerOrder: {
      amount: number;
      currency: string;
    };
    maxCharge?: {
      amount: number;
      currency: string;
    };
  };
  groceryConfig: {
    tier: string;
    unit: string;
    chargePerUnit: {
      amount: number;
      currency: string;
    };
    chargePerOrder: {
      amount: number;
      currency: string;
    };
    maxCharge?: {
      amount: number;
      currency: string;
    };
  };
};

export const getServiceFee = async (callerId: string): Promise<ServiceFeeResponse> => {
  const response = await sendGet(`callers/${callerId}/getServiceFee`);

  return response.data;
};
